import { useNavigate } from "react-router";
import logoIISS from "../assets/iiss-logo.png";
import Button from "../components/Button";
import { useTranslation } from "../i18n/TranslationProvider";
import { useRef } from "react";

// this allows the videos to have a cleaner select state for keyboard navigation
function KeyboardVideo({ src, title }) {
    const iframeRef = useRef(null);

    const enterVideo = () => {
        iframeRef.current?.focus();
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            enterVideo();
        }
    };

    return (
        <div
            className="aspect-video w-full rounded focus:outline-none focus:ring-4 focus:ring-teal-500 focus:ring-offset-2"
            tabIndex={0}
            role="group"
            aria-label={`${title}. Press Enter or Space to enter the video player.`}
            onKeyDown={handleKeyDown}
        >
            <iframe
                ref={iframeRef}
                className="w-full h-full rounded"
                src={src}
                title={title}
                allowFullScreen
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                tabIndex={-1}
            />
        </div>
    );
}

function Landing() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="custom-container mx-auto w-4/5 lg:w-1/2">
            <div className="flex flex-col gap-6 md:flex-row items-center">
                <img src={logoIISS} alt="IISS"className="md:-mt-6 w-48 md:w-64 h-auto" />
                <div className="md:pt-6 -mt-4">
                    <h1 className="text-lg md:text-2xl text-center mx-auto">
                        {t("landing.welcome")}
                    </h1>
                    {/* NOTE: acronym breakdown kept English-only on purpose —
                        the bolded letters (I-I-S-S) are tied to the English
                        words. Translating this sentence breaks the visual
                        letter match. Flag to Lynne if this needs a
                        language-specific treatment instead. */}
                    <p className="text-center mx-auto mb-2">
                        (The <b>I</b>njury <b>I</b>mpact <b>S</b>everity{" "}
                        <b>S</b>core) <br />
                    </p>
                    <p className="text-center mx-auto italic">
                        {t("landing.tagline")}
                    </p>
                </div>
            </div>
        
            <p className="text-center my-4 md:my-6">
            
                    {t("landing.descriptionPart1")}{" "}
                    <span className="font-bold italic"> {t("landing.descriptionShould")} </span>
                    {t("landing.descriptionPart2")}{" "}
                    <a
                        href="https://nsuworks.nova.edu/neurosports/vol1/iss2/19/"
                        className="text-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 rounded"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("landing.descriptionPeerReviewed")}
                        <span className="sr-only"> (opens in a new tab)</span>
                    </a>{" "}
                    {t("landing.descriptionPart3")}
       
            </p>
           <div className="my-6 flex flex-col md:flex-row gap-6">
    <div className="flex-1">
        <h2 className="text-lg mb-2 text-center font-semibold">
            {t("landing.sportsHeading")}
        </h2>

        <KeyboardVideo
            src="https://www.youtube.com/embed/-uKhw_ShlKs"
            title={t("landing.videoTitleSports")}
        />
    </div>

    <div className="flex-1">
        <h2 className="text-lg mb-2 text-center font-semibold">
            {t("landing.emrHeading")}
        </h2>

        <KeyboardVideo
            src="https://www.youtube.com/embed/TynaaAh5v-Y"
            title={t("landing.videoTitleEmr")}
        />
    </div>
</div>
            {/* Login / Register section */}

            <hr className="my-6 border border-gray-200 w-full p-0 mx-auto" />

           <h3 className="text-base md:text-xl text-center mx-auto">
                {t("landing.readyToStart")}
            </h3>

           
            <div className="mt-4 px-2 text-center">
                <button
                    type="button"
                    className=" inline-block text-teal-600 text-lg bg-teal-50 hover:bg-teal-100 py-3 px-6 rounded-md transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-teal-500"
                    onClick={() => navigate("/login")}
                >
                    {t("landing.login")}
                </button>
            </div>
            
           <div className="mt-2 px-2 flex items-center justify-center space-x-1">
                <p>{t("landing.noAccount")}</p>
                <button
                    type="button"
                    className="text-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 rounded"
                    onClick={() => navigate("/register")}
                >
                    {t("landing.register")}
                </button>
            </div>

           <div className="mt-2 px-2 flex items-center justify-center space-x-1">
                <p>{t("landing.needHelp")}</p>
                <button
                    type="button"
                    className="text-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 rounded"
                    onClick={() => navigate("/help")}
                >
                    {t("landing.contactUs")}
                </button>
            </div>

                
            <hr className="mt-6 border border-gray-200 w-full p-0 mx-auto" />
            
            
        </div>
    );
}

export default Landing;